import Sticky from 'react-sticky-el'

export { Sticky }
